import {Injectable, InjectionToken} from "@angular/core";

export let WINDOW_TOKEN = new InjectionToken("generic.window");

export interface IWindowEventsRegister {
	addEventListener<K extends keyof WindowEventMap>(eventName: K, listener: (this: Window, ev: WindowEventMap[K]) => any, useCapture?: boolean);

	removeEventListener<K extends keyof WindowEventMap>(eventName: K, listener: (this: Window, ev: WindowEventMap[K]) => any, useCapture?: boolean);
}

@Injectable()
export class WindowEventsNodeService implements IWindowEventsRegister {
	public addEventListener<K extends keyof WindowEventMap>(eventName: K, listener: (this: Window, ev: WindowEventMap[K]) => any) {
		// do nothing
	}

	public removeEventListener<K extends keyof WindowEventMap>(eventName: K, listener: (this: Window, ev: WindowEventMap[K]) => any) {
		// do nothing
	}
}

@Injectable()
export class WindowEventsBrowserService implements IWindowEventsRegister {
	public addEventListener<K extends keyof WindowEventMap>(eventName: K,
		listener: (this: Window, ev: WindowEventMap[K]) => any, useCapture ?: boolean) {
		// Window events will be dispatched to the registered listener
		// before being dispatched to any EventTarget beneath it in the DOM tree.
		window.addEventListener(eventName, listener, useCapture);
	}

	public removeEventListener<K extends keyof WindowEventMap>(eventName: K,
		listener: (this: Window, ev: WindowEventMap[K]) => any, useCapture ?: boolean) {
		window.removeEventListener(eventName, listener, useCapture);
	}
}
